<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <baseaktarim
      :logo="'8Q'"
      :title="'ONUR AIR Bilet ' + $t('Transfer')"
      v-model="items"
      v-on:submitfile="SubmitFile"
      :status="status"
    ></baseaktarim>
  </div>
</template>

<script>
import baseaktarim from "../aktarimbilet/baseaktarim";
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      items: [],
      status: tool.NewSatatus(),
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  components: {
    baseaktarim,
    yetkidialog,
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status != true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  methods: {
    SubmitFile(files,params) {
      let formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append("files[" + i + "]", file);
      }
formData.append("InternetSatis", params && params.InternetSatis ? true : false);
      this.status.loading = true;
      tool
        .api_file_post(this, "ArkmanTicketStream/OnurAirStream", formData)
        .then(
          (response) => {
            this.items = response.body;
            this.status.loading = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
    },
  },
};
</script>
